<template>
  <div class="bg-white py-1 px-2 rounded pin-b pin-l flex items-center">
    <div class="text-black font-bold mr-3 hidden lg:block" style="font-size: 0.65rem;">Legenda</div>
    <div class="flex flex-row lg:flex-col">
      <div class="flex flex-col lg:flex-row">
        <div class="flex items-center mr-3" v-if="areaLevel === 'province' || areaLevel === 'district' || areaLevel === 'zone' || areaLevel === 'school'">
          <div style="border-bottom: 2px solid #221d13; width: 20px;"></div>
          <div class="ml-1" style="font-size: 0.65rem;">Batas wilayah</div>
        </div>
        <div class="flex items-center mr-3" v-if="areaLevel === 'zone' || areaLevel === 'school'">
          <div style="border-bottom: 2px solid #38c172; width: 20px;"></div>
          <div class="ml-1" style="font-size: 0.65rem;">Batas zona</div>
        </div>
        <div class="flex items-center mr-3" v-if="areaLevel === 'school'">
          <div style="border-bottom: 2px solid #267bbe; width: 20px;"></div>
          <div class="ml-1" style="font-size: 0.65rem;">Redistribusi satu zona</div>
        </div>
        <div class="flex items-center mr-3" v-if="areaLevel === 'school'">
          <div style="border-bottom: 2px solid #be262f; width: 20px;"></div>
          <div class="ml-1" style="font-size: 0.65rem;">Redistribusi antar zona</div>
        </div>
      </div>
      <div v-if="areaLevel === 'school'" class="flex flex-row">
        <div class="flex flex-col lg:flex-row">
          <div class="flex items-center mr-3">
            <div class="flex justify-center" style="width: 20px;">
              <div style="background-color: #DF3A01; border-radius: 50%; width: 8px; height: 8px;"></div>
            </div>
            <div class="ml-1" style="font-size: 0.65rem;">SD</div>
          </div>
          <div class="flex items-center mr-3">
            <div class="flex justify-center" style="width: 20px;">
              <div style="background-color: #01A9DB; border-radius: 50%; width: 8px; height: 8px;"></div>
            </div>
            <div class="ml-1" style="font-size: 0.65rem;">SMP</div>
          </div>
          <div class="flex items-center mr-3">
            <div class="flex justify-center" style="width: 20px;">
              <div style="background-color: #848484; border-radius: 50%; width: 8px; height: 8px;"></div>
            </div>
            <div class="ml-1" style="font-size: 0.65rem;">SMA</div>
          </div>
        </div>
        <div class="flex flex-col lg:flex-row">
          <div class="flex items-center mr-3">
            <div class="flex justify-center" style="width: 20px;">
              <div style="background-color: #196f3d; border-radius: 50%; width: 8px; height: 8px;"></div>
            </div>
            <div class="ml-1" style="font-size: 0.65rem;">SMK</div>
          </div>
          <div class="flex items-center mr-3">
            <div class="flex justify-center" style="width: 20px;">
              <div style="background-color: #ffc300; border-radius: 50%; width: 8px; height: 8px;"></div>
            </div>
            <div class="ml-1" style="font-size: 0.65rem;">PKBM</div>
          </div>
          <div class="flex items-center mr-3">
            <div class="flex justify-center" style="width: 20px;">
              <div style="background-color: #333333; border-radius: 50%; width: 8px; height: 8px;"></div>
            </div>
            <div class="ml-1" style="font-size: 0.65rem;">Lainnya</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'legends',
  props: {
    areaLevel: String
  }
}
</script>
